import { render } from "./AddTicket.vue?vue&type=template&id=0c91c520&scoped=true"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"

import "./AddTicket.vue?vue&type=style&index=0&id=0c91c520&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c91c520"]])

export default __exports__